import React from "react";
import { NavLink, useLocation } from "react-router-dom";

import {
  Nav,
  NavList,
  NavItem
} from "@patternfly/react-core";

import { AngleDownIcon } from "@patternfly/react-icons";

import useMenu from "../hooks/useMenu";
import useNavigation from "../hooks/useNavigation";

import "../SchoolNavigation.css";

const SchoolNavigationDesktop = () => {
  const { menu } = useMenu();
  const location = useLocation();
  const isItemActive = (item) => {
    if (item.to && item.to !== "/") {
      return (
        location.pathname === item.to ||
        location.pathname.startsWith(`${item.to}/`)
      );
    }

    if (item.megaMenu?.sections) {
      return item.megaMenu.sections.some((section) =>
        section.links?.some(
          (link) =>
            !link.external &&
            link.to &&
            (
              location.pathname === link.to ||
              location.pathname.startsWith(`${link.to}/`)
            )
        )
      );
    }

    return item.to === "/" && location.pathname === "/";
  };
  const {
    activeMenu,
    openMegaMenu,
    closeMegaMenu,
    enterNav,
    leaveNav,
  } = useNavigation();

  return (
    <Nav
      variant="horizontal"
      aria-label="School navigation"
      onMouseEnter={enterNav}
      onMouseLeave={leaveNav}
    >
      <NavList>
        {menu.map((item) => {
          const hasMegaMenu = !!item.megaMenu?.sections?.length;

          return (
            <NavItem
              key={item.id}
              itemId={item.id}
              isActive={isItemActive(item)}
            >
              {hasMegaMenu ? (
                <span
                  className="school-nav-item"
                  onMouseEnter={(e) =>
                    openMegaMenu(item.id, e.currentTarget)
                  }
                >
                  {item.label}

                  <AngleDownIcon
                    className={
                      activeMenu === item.id
                        ? "school-nav-arrow school-nav-arrow--open"
                        : "school-nav-arrow"
                    }
                  />
                </span>
              ) : (
                <NavLink
                  to={item.to}
                  className="school-nav-item"
                  onMouseEnter={closeMegaMenu}
                >
                  {item.label}
                </NavLink>
              )}
            </NavItem>
          );
        })}
      </NavList>
    </Nav>
  );
};

export default SchoolNavigationDesktop;